import {mapStyles, addInitMap, slideDown, slideUp} from "../helpers";

class OfficesMap {
	constructor(el) {
		this.el          = el
		this.map         = this.el.querySelector( '.offices-map__map' )
		this.details     = this.el.querySelectorAll( '.offices-map__details .offices-map__detail' )
		this.listItems   = this.el.querySelectorAll( '.offices-map__list .offices-map__list-item' )
		this.offices     = JSON.parse( this.el.querySelector( '.offices-map__json' ).textContent )
		this.markers     = []
		this.activeIndex = false

		const self = this
		addInitMap(
			function () {
				self.init()
			}
		)
	}

	init() {
		Array.from( this.listItems ).forEach(
			(item, index) => {
				item.addEventListener(
					'click',
					e => {
						e.preventDefault()
						this.selectOffice( index )
					}
				)
			}
		)

		if (typeof window.google.maps.Map !== 'undefined') {
			this.Map = new window.google.maps.Map(
				this.map,
				{
					center: {
						lat: 52.35839852323313,
						lng: 19.100845158579418
					},
					zoom: 6,
					styles: mapStyles()
				}
			)

			this.offices.forEach(
				(office, index) => {
					let markerOptions = {
						map: this.Map,
						title: office.title,
						position: {
							lat: office.lat,
							lng: office.lng,
							},
					}

					if (typeof window.googleMaps.pinUrl === 'string') {
						markerOptions = {
							...markerOptions,
							...{
								icon: window.googleMaps.pinUrl
							}
						}
					}

					const marker = new window.google.maps.Marker( markerOptions )

					marker.addListener( 'click', e => this.selectOffice( index ) )

					this.markers.push( marker )
				}
			)
		}
	}

	selectOffice(index) {
		let time = 0
		if (Number.isInteger( this.activeIndex )) {
			slideUp( Array.from( this.details )[this.activeIndex] )
			time = 300
			if (typeof window.googleMaps.pinUrl === 'string') {
				this.markers[this.activeIndex].setIcon( window.googleMaps.pinUrl )
			}
		}

		if (index !== this.activeIndex) {
			if (typeof window.googleMaps.activePinUrl === 'string') {
				this.markers[index].setIcon( window.googleMaps.activePinUrl )
			}

			setTimeout(
				() => {
					slideDown( Array.from( this.details )[index] )
				},
				time
			)
			this.activeIndex = index
		} else {
			this.activeIndex = false
		}
	}
}

(() => {
	Array.from( document.querySelectorAll( '.offices-map' ) ).forEach( item => new OfficesMap( item ) )
})()
